import React from 'react';
import { AdControlProvider } from '@atlassian/ad-control-toolkit';
import { AppRecommendationsContext } from '../../controllers/app-recommendations-provider';
import { ArkIntlProvider } from '../ark-intl-provider';
const AppRecommendationsProvider = ({
  onEvents,
  children,
  contextResolver,
  endpoint
}) => {
  const handleOnEvents = React.useCallback(event => {
    onEvents === null || onEvents === void 0 ? void 0 : onEvents(event);
  }, [onEvents]);
  return /*#__PURE__*/React.createElement(ArkIntlProvider, null, /*#__PURE__*/React.createElement(AdControlProvider, {
    onEvents: handleOnEvents
  }, /*#__PURE__*/React.createElement(AppRecommendationsContext.Provider, {
    value: {
      onEvents: handleOnEvents,
      contextResolver,
      endpoint
    }
  }, children)));
};
export default AppRecommendationsProvider;